import {
  useMemo } from "react";
  import { useTranslation } from "react-i18next";
  import {
  ToolOutlined,
  ThunderboltOutlined,
  SafetyCertificateOutlined,
  RiseOutlined,
  BarcodeOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByIndex: Record<number, JSX.Element> = {
  0: <ToolOutlined />,
  1: <ThunderboltOutlined />,
  2: <SafetyCertificateOutlined />,
  3: <BarcodeOutlined />,
};

const BenefitsSection = () => {
  const { t } = useTranslation("mes");

  const items = useMemo(() => {
    const raw = t("benefits.items", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ title: string; desc: string }>;
  }, [t]);

  return (
    <section className="dev-mes-section dev-mes-benefits-section">
      <div className="dev-mes-section-inner">
        <h2 className="dev-section-h2 dev-mes-section-h2">
          <span className="dev-mes-section-h2-icon dev-mes-section-h2-icon--amber" aria-hidden>
            <RiseOutlined />
          </span>
          <span>{t("benefits.title")}</span>
        </h2>

        <div className="dev-mes-benefits-grid">
          {items.slice(0, 5).map((item, idx) => (
            <div key={idx} className="dev-mes-benefit-card">
              <div className="dev-mes-benefit-left">
                <span className="dev-mes-benefit-number">{String(idx + 1).padStart(2, "0")}</span>
                <span className="dev-mes-benefit-icon">{iconByIndex[idx] ?? null}</span>
              </div>
              <div className="dev-mes-benefit-body">
                <div className="dev-mes-benefit-title">{item.title}</div>
                <div className="dev-mes-benefit-desc">{item.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
